<template>
  <article>
    <section class="base_content">
      <form>
        <div>
          <span>{{ formData.formPlaceHolders.name }}</span
          ><input
            dir="auto"
            type="text"
            name="name"
            v-model.trim="name"
            required
          />
        </div>
        <div>
          <span>{{ formData.formPlaceHolders.address }}</span
          ><input
            dir="auto"
            type="text"
            name="address"
            v-model.trim="address"
            required
          />
        </div>
        <div>
          <span>{{ formData.formPlaceHolders.mobileNumber }}</span
          ><input
            dir="auto"
            name="mobile"
            type="text"
            v-model.trim="phoneNumber"
            required
          />
        </div>
        <div>
          <span>{{ formData.formPlaceHolders.email }}</span
          ><input
            dir="auto"
            name="email"
            type="email"
            v-model.trim="email"
            required
          />
        </div>
      </form>
      <div class="img_container">
        <img
          src="@/assets/surface.png"
          alt="screen Image"
          loading="lazy"
          draggable="false"
        />
      </div>
    </section>
    <div class="footer">
      <p>
        <bdi>
          {{
            backAction
              ? designYourNeeds.designYourNeedsMessage + " "
              : `${formData.versionRequestFooterMessage + versionName} = `
          }}
        </bdi>
        <bdi>{{ totalPrice + " " + currency }}</bdi>
      </p>
      <div class="btns_container">
        <button v-if="backAction" @click="backAction" class="backButton">
          {{ formData.backButtonText }}
          <i class="fas fa-forward" />
        </button>

        <button v-else @click="closeModal" class="backButton">
          {{ formData.cancleButtonText }}
        </button>
        <button type="submit" class="submitButton" @click="submitAction">
          {{ formData.submitButtonText }}
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import { isValidEmail } from "@/util/methods";
import swal from "sweetalert";
import Form from "@/util/GoogleForm";
export default {
  name: "SendClientDataToBuy",
  data() {
    return {
      name: "",
      address: "",
      phoneNumber: "",
      email: "",
    };
  },
  props: [
    "backAction",
    "currency",
    "totalPrice",
    "closeModal",
    "selectedProps",
    "versionName",
    "designYourNeeds",
    "programName",
  ],
  methods: {
    isValidEmail,
    resetInputsData() {
      this.name = "";
      this.address = "";
      this.phoneNumber = "";
      this.email = "";
    },
    submitAction() {
      let {
        name,
        address,
        phoneNumber,
        email,
        totalPrice,
        selectedProps,
        programName,
        versionName,
      } = this;
      const alertMessage = this.designYourNeeds.alertMessages;
      if (!(name && address && phoneNumber && email)) {
        swal({
          title: alertMessage.dataRequired.title,
          text: alertMessage.dataRequired.text,
          icon: "info",
          button: alertMessage.dataRequired.buttonText,
        });
        return;
      }
      if (!isValidEmail(email)) {
        swal({
          title: alertMessage.inValidEmail.title,
          text: alertMessage.inValidEmail.text,
          icon: "info",
          button: alertMessage.inValidEmail.buttonText,
        });
        return;
      }

      const requestParams = {
        programName,
        name,
        address,
        phoneNumber,
        email,
        totalPrice,
      };
      let serializeProps = [];
      if (selectedProps) {
        serializeProps = Object.values(selectedProps).map((prop) => {
          if (prop?.type == "numeric") {
            return `${prop.num} ${prop.name}`;
          }
          return prop.name;
        });
      }
      requestParams["fearures"] = selectedProps
        ? serializeProps.join("\n")
        : versionName;

      new Form("1FAIpQLSdnG4EyTM8kDXqkJrHk98tKfDFSd2m_AVdeJbm4cKOexT5O1Q", {
        "entry.111508433": "programName",
        "entry.61010373": "name",
        "entry.860910215": "address",
        "entry.824413663": "phoneNumber",
        "entry.151688349": "email",
        "entry.1959767525": "totalPrice",
        "entry.801183603": "fearures",
      }).submit(requestParams);

      swal({
        title: alertMessage.submitSuccess.title,
        text: alertMessage.submitSuccess.text,
        icon: "success",
        button: alertMessage.submitSuccess.buttonText,
      });

      this.closeModal();
      this.resetInputsData();
    },
  },
  computed: {
    formData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].sendRequestData;
    },
  },
};
</script>

<style></style>
